"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var to_string_1 = require("./to-string");
var upperCase = function (str) {
    return to_string_1.default(str).toUpperCase();
};
exports.default = upperCase;
//# sourceMappingURL=upper-case.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/upper-case.js
// module id = 1158
// module chunks = 37